import React from 'react';

const SearchBar = ({ value, onChange, placeholder = 'Buscar en el manual…' }) => (
  <div className="manual-search">
    <input
      type="search"
      className="manual-search__input"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      aria-label="Buscar en el manual"
    />
    <span className="manual-search__icon" aria-hidden="true">🔍</span>
  </div>
);

export default SearchBar;

